import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { currentUserId } from '../../../../entities/auth/session/selectors';
import { IThunkDispatch } from '../../../../store/middleware';
import { IState } from '../../../../store/reducer';
import { IAction } from '../../../components/action/types';
import { useDataLoad } from '../../../helpers/hooks';
import { getCustomerActions } from '../actions';
import { ActionDetailsComponent } from './ActionDetails';

interface IActionDetailsContainerProps {
	action: IAction | undefined;
	customerId: string;
	getCustomerActions: (id: string) => Promise<any>;
}

const mapStateToProps = (id: string, actionType: string) => (state: IState) => {
	const customerId = currentUserId(state);
	const actions = state.views.actions.byOwnerId[customerId];

	const action = actions && actions
		.filter((a) => a.type === actionType)
		.find(({ consumer }) => consumer.id === id);

	return {
		action,
		customerId,
	};
};

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getCustomerActions: async (id: string) => {
		await dispatch(getCustomerActions(id)).catch((e: any) => e);
	}
});

export const Action = () => {
	const params = useParams();
	const actionType = params.actionType || '';
	const id = params.id || '';

	const pp: IActionDetailsContainerProps = {
		...useSelector(mapStateToProps(id, actionType)),
		...mapDispatchToProps(useDispatch())
	};

	const loading = useDataLoad(
		!pp.action, async () => await pp.getCustomerActions(pp.customerId)
	);
	return <ActionDetailsComponent {...pp} loading={loading} />;
};
